export default {
  enterValid: 'Please enter the valid',
  pageName: 'Page name',
  pageNamePlaceholder: 'Enter page name',
  createNewPage: 'Create new page',
  editPage: 'Editpage',
  subDomain: 'Subdomain',
  subDomainPlaceholder: 'Enter Subdomain i.e goods,books,architectures etc.',
  profix: 'Profix',
  pageTypePlaceholder: 'Select Page type',
  createMember: 'Add new member',
  firstName: 'First Name',
  lastName: 'Last Name',
  emailPlaceholder: 'Enter email address',
  password: 'Password',
  avatar: 'avatar',
  userName: 'Username',
  role: 'Select Role',
  roleError: 'Please select a role',
  createTeam: 'Create new team',
  id: 'ID',
  team: 'Team',
  manager: 'Manager',
  countries: 'Countries',
  search: 'Search',
  groups: 'Groups',
  allAdmin: 'All Admin',
  pending: 'Pending',
  active: 'Active',
  partner: 'Partner',
  partners: 'Partners',
  former: 'Member Former',
  memberNow: 'Member Now',
  partnerId: 'PARTNER ID',
  country: 'COUNTRY',
  companyName: 'COMPANY NAME',
  group: 'GROUP',
  date: 'Date',
  readerId: 'READER ID',
  lastIp: 'IP LAST LOGIN',
  readerName: 'READER NAME',
  email: 'EMAIL',
  joint: 'JOINT',
  hours: 'HOURS',
  visited: 'VISITED',
  favorite: 'FAVORITE',
  lastLogin: 'LAST LOGIN',
  logo: 'LOGO',
  postsPerPage: 'Posts per page',
  move: 'Move',
  delete: 'Delete',
  duplicate: 'Duplicate',
  actions: 'Actions',
  languages: 'Languages',
  inactive: 'Inactive',
  display: 'Display',
  competition: 'Competition',
  postName: 'POST NAME',
  publishedDate: 'PUBLISHED DATE',
  pages: 'PAGES',
  editPost: 'POST EDIT',
  newChat: 'New Chat',
  finshedChat: 'Finished Chat',
  chat: 'Chat',
  images: 'IMAGES',
  datePublished: 'PUBLISHED DATE',
  year: 'Year',
  timeline: 'Timeline',
  amount: 'Amount',
  postYYYY: 'Publishing (post yyyy)',
  applicationYYYY: 'Application (candidate yyyy)',
  winnerYYYY: 'Selection (winner yyyy)',
};
